import { render } from "./UpcomingDrawCard.vue?vue&type=template&id=4d8df9b0&scoped=true&ts=true"
import script from "./UpcomingDrawCard.vue?vue&type=script&lang=ts"
export * from "./UpcomingDrawCard.vue?vue&type=script&lang=ts"

import "./UpcomingDrawCard.vue?vue&type=style&index=0&id=4d8df9b0&scoped=true&lang=scss"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8df9b0"]])

export default __exports__